import MyService from '../../service';
import { reactLocalStorage } from 'reactjs-localstorage';
import { get } from 'lodash';

const BookingApi = {
  getBookingCancel: async () => {
    try {
      const { data } = await MyService.getRequestData('/booking/cancel');
      return data || [];
    } catch (error) {
      console.log(error);
      return [];
    }
  },

  getAllBetweenTime: async (sdate, edate, loadByTime) => {
    try {
      const { data } = await MyService.getRequestData(
        '/booking/get-between-time',
        {
          sdate,
          edate,
          loadByTime,
        }
      );

      return data;
    } catch (e) {
      console.error(e);
      return [];
    }
  },

  getListForPart: async (part_id) => {
    if (!part_id) {
      return;
    }
    let bookings = null;
    await MyService.getRequestData('/booking/list-for-part', { part_id })
      .then((result) => (bookings = result.data))
      .catch((err) => console.log(err));
    return bookings;
  },
  getStatisticReason: async (obj) => {
    let data = null;
    await MyService.getRequestData('/booking/statistic-reason', obj)
      .then((result) => (data = result.data))
      .catch((err) => console.log(err));
    return data;
  },
  getStatisticLevel: async (obj) => {
    let data = null;
    await MyService.getRequestData('/booking/statistic-level', obj)
      .then((result) => (data = result.data))
      .catch((err) => console.log(err));
    return data;
  },
  getStatisticLevelWeek: async (obj) => {
    let data = null;
    await MyService.getRequestData('/booking/statistic-level-week', obj)
      .then((result) => (data = result.data))
      .catch((err) => console.log(err));
    return data;
  },
  getLevels: async () => {
    let status = null;
    await MyService.getRequestData('/booking/all-status')
      .then((result) => (status = result.data))
      .catch((err) => console.log(err));

    return status;
  },
  createBooking: async (data) => {
    data.isFromBackend = true;
    data.createFrom = 'backend';

    return MyService.postRequestData('/booking', data);
  },
  getReasons: async () => {
    let reasons = null;
    await MyService.getRequestData('/booking/all-reasons')
      .then((result) => (reasons = result.data))
      .catch((err) => console.log(err));

    return reasons;
  },
  getSources: async () => {
    let sources = null;
    await MyService.getRequestData('/booking/all-sources')
      .then((result) => (sources = result.data))
      .catch((err) => console.log(err));

    return sources;
  },
  getDetailPriceBooking: async (options) => {
    console.log(options);
    let detailPrice = null;
    await MyService.getRequestData('/booking/detail-price', options)
      .then((result) => {
        detailPrice = result.data;
      })
      .catch((err) => console.log(err));
    return detailPrice;
  },
  delete: async (book_id) => {
    let result = null;
    result = await MyService.putRequestData('/booking/delete', { book_id });

    return result;
  },
  updateLevel: async (book_id, book_stt_id) => {
    let result = null;
    result = await MyService.putRequestData('/booking/update-level', {
      book_id,
      book_stt_id,
    });

    return result;
  },
  quickEdit: async (obj) => {
    if (!obj.book_id) {
      return { code: 'error', message: 'book_id is require' };
    }
    let result = null;
    result = await MyService.putRequestData('/booking/quick-edit', obj);

    return result;
  },
  editBooking: (data) => {
    if (!data.book_code) {
      throw new Error('book_code is required');
    }

    data.isFromBackend = true;

    return MyService.putRequestData('/booking/edit', data);
  },
  getBookingByCode: async (code) => {
    try {
      const { data } = await MyService.getRequestData(
        `/booking/get-detail-booking-full/${code}`
      );

      return data;
    } catch (e) {
      console.log(e);
      return null;
    }
  },

  getBookingByUser: async (userAccountId) => {
    const user = reactLocalStorage.getObject('user.info');
    if (!user) return null;
    var token = get(user, 'user_acc_tokn');
    try {
      const { data } = await MyService.getRequestData(
        `/booking/get-rental-history-user?user_acc_id=${userAccountId}`,
        '',
        token
      );

      return data;
    } catch (e) {
      console.log(e);
      return null;
    }
  },

  searchByCode: async (code) => {
    try {
      const { data } = await MyService.getRequestData(
        `/booking/search-by-code/${code}`
      );
      return data;
    } catch (e) {
      console.log(e);
      return null;
    }
  },

  getBookingWithPromoCode: async (code) => {
    try {
      const { data } = await MyService.getRequestData(
        `/booking/get-booking-with-promo-code/${code}`
      );
      return data;
    } catch (e) {
      console.log(e);
      return null;
    }
  },
  getPromotion: async (options) => {
    let promotion = null;
    await MyService.getRequestData('/booking/promotion', options)
      .then((result) => {
        console.log(result);
        promotion = result;
      })
      .catch((err) => console.log(err));
    return promotion;
  },
  getDeliPrice: async (options) => {
    let deliPrice = null;
    await MyService.getRequestData('/booking/deli-price', options)
      .then((result) => {
        deliPrice = result.data;
      })
      .catch((err) => console.log(err));
    return deliPrice;
  },
  forwardBooking: async (book_id) => {
    let book;
    await MyService.putRequestData('/booking/update-date-booking', {
      book_id,
      field_name: 'book_time_send_part',
    })
      .then((result) => (book = result))
      .catch((err) => console.log(err));
    return book;
  },
  acceptBooking: async (book_id) => {
    let book;
    await MyService.putRequestData('/booking/update-date-booking', {
      book_id,
      field_name: 'book_time_part_acpt',
    })
      .then((result) => (book = result))
      .catch((err) => console.log(err));

    return book;
  },
  cancelBooking: async (book_id) => {
    let book;
    await MyService.putRequestData('/booking/update-cancel-booking', {
      book_id,
    })
      .then((result) => (book = result))
      .catch((err) => console.log(err));

    return book;
  },
  postSendMail: async (options) => {
    if (
      !options ||
      !options.cstm_emai ||
      !options.subject ||
      !options.content
    ) {
      alert('Thông tin chưa đủ');
      return null;
    }
    let result = null;
    await MyService.postRequestData('/booking/send-email', options)
      .then((data) => (result = data))
      .catch((err) => console.log(err));
    return result;
  },
  resendMail: async (option) => {
    if (!option.bookingCode) {
      alert('Missing Booking Code!');
      return null;
    }
    let result = null;
    await MyService.postRequestData('/booking/resend-email', option)
      .then((data) => (result = data))
      .catch((err) => console.log(err));
    return result;
  },
  getBookingByCodeAndHash: async (code, hash) => {
    let booking = null;
    await MyService.getRequestData(
      `/booking/get-detail-booking-hash/${code}?hash=${hash}`
    )
      .then((result) => {
        console.log(result);
        booking = result.data;
      })
      .catch((err) => console.log(err));
    return booking;
  },
};
export default BookingApi;

export const bookingPurposes = [
  'Thuê xe cưới',
  'Du lịch',
  'Về quê',
  'Công tác',
  'Thuê cho công ty',
  'Cá nhân',
  'Ngoại giao',
  'Đi sự kiện',
  'KXD',
  'Khác',
];
